import type { FunctionComponent } from "react";

import { StyledDiv } from "./styles";

export const AuthorHeaderBar: FunctionComponent = () => <StyledDiv />;

AuthorHeaderBar.displayName = "AuthorHeaderBar";
